import { render, staticRenderFns } from "./TrimmedLogo.vue?vue&type=template&id=565a1b6a"
import script from "./TrimmedLogo.vue?vue&type=script&lang=ts"
export * from "./TrimmedLogo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports